import { render } from "./WELCOME.vue?vue&type=template&id=0548cbb8&ts=true"
import script from "./WELCOME.vue?vue&type=script&lang=ts"
export * from "./WELCOME.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__